import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const download = async (code) => {
  try {
    const res = await api.get(`/admin/study-guides/${code}`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url; a.download = `CSI-${code}-Study-Guide.pdf`; a.click();
    URL.revokeObjectURL(url);
  } catch { toast.error("Download failed"); }
};

export const StudyGuidesTab = () => {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState("");
  const load = () => api.get("/admin/study-guides").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (code, file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setBusy(code);
    try {
      const { data } = await api.post(`/admin/study-guides/${code}`, fd);
      toast.success(`Replaced - ${data.pages} pages`);
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Upload failed"); }
    setBusy("");
  };
  const reset = async (code) => {
    if (!window.confirm("Remove your uploaded PDF and go back to the CSI-generated guide?")) return;
    await api.delete(`/admin/study-guides/${code}`); load();
  };

  return (
    <section className="space-y-3" data-testid="admin-study-guides">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-zinc-600">Study guides unlock for students together with the exam after payment and enrolment. Download to review, or upload your own PDF to replace one.</p>
        <button onClick={async () => {
          try {
            const res = await api.get("/admin/study-guides/revision-report", { responseType: "blob" });
            const url = URL.createObjectURL(res.data); const a = document.createElement("a");
            a.href = url; a.download = "CSI-Study-Guides-Revision-Report.pdf"; a.click(); URL.revokeObjectURL(url);
          } catch { toast.error("Download failed"); }
        }} className="chip text-sm" data-testid="study-guides-revision-report-btn">Download revision report &amp; change log</button>
      </div>
      {rows.map((g) => (
        <div key={g.code} className="card-warm p-4 flex items-center justify-between gap-3 flex-wrap" data-testid={`study-guide-row-${g.code}`}>
          <div className="min-w-0">
            <div className="font-semibold">{g.title}</div>
            <div className="text-xs text-zinc-600">
              {g.source === "missing" ? "Not available yet" : `${g.source === "uploaded" ? "Your upload" : "CSI-generated"} · ${g.pages || "?"} pages`}
              {g.updated_at ? ` · ${new Date(g.updated_at).toLocaleDateString()}` : ""} · Courses: {g.courses.join(", ")}
            </div>
          </div>
          <div className="flex gap-2 flex-wrap">
            {g.source !== "missing" && <button onClick={() => download(g.code)} className="chip text-xs" data-testid={`study-guide-admin-download-${g.code}`}>Download</button>}
            <label className={`chip text-xs cursor-pointer ${busy === g.code ? "opacity-50" : ""}`} data-testid={`study-guide-upload-${g.code}`}>
              {busy === g.code ? "Uploading…" : "Replace PDF"}
              <input type="file" accept="application/pdf" className="hidden" onChange={(e) => upload(g.code, e.target.files?.[0])}/>
            </label>
            {g.source === "uploaded" && <button onClick={() => reset(g.code)} className="chip text-xs text-red-700" data-testid={`study-guide-reset-${g.code}`}>Use generated</button>}
          </div>
        </div>
      ))}
    </section>
  );
};
